import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import CartoonButton from '../../CartoonButton.component';
import { SubmittedBadge } from './ClosestNumber.game';
import { MinigameStateSnapshot } from '../../../shared/events';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.08); }
`;

interface Props {
  minigame: MinigameStateSnapshot;
  submitted: boolean;
  onSubmit: (answer: number) => void;
}

const FastestTap: React.FC<Props> = ({ minigame, submitted, onSubmit }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const readyAt = minigame.readyAt ?? Date.now();
    const delay = readyAt - Date.now();
    if (delay <= 0) { setReady(true); return; }
    const t = setTimeout(() => setReady(true), delay);
    return () => clearTimeout(t);
  }, [minigame.readyAt]);

  if (submitted) return <SubmittedBadge label="Nice tap!" />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
      {ready ? (
        <CartoonButton
          variant="contained"
          onClick={() => onSubmit(Date.now())}
          sx={{
            background: '#ff9800',
            width: 180, height: 180, borderRadius: '50%',
            fontSize: '1.8rem', fontWeight: 'bold',
            boxShadow: '0 8px 0 rgba(0,0,0,0.4)',
            animation: `${pulse} 0.5s ease-in-out infinite`,
          }}
        >
          TAP!
        </CartoonButton>
      ) : (
        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', fontSize: '1.3rem', color: 'rgba(255,255,255,0.6)', fontWeight: 'bold' }}>
            Get ready…
          </Typography>
          <Typography sx={{ fontFamily: '"Comic Sans MS", cursive', fontSize: '0.85rem', color: 'rgba(255,255,255,0.4)', mt: 1 }}>
            Don't tap early!
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default FastestTap;
